//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Search,Field, Cascader, Popup} from 'vant';
import { getJson, getGeoTwoData} from '@/api/address'
window._AMapSecurityConfig = {
  securityJsCode: "2e95064c4df2c6f815b452e2e7abee56" //你的安全密钥
};
let AMap = null,marker=null;
import AMapLoader from "@amap/amap-jsapi-loader";
export default {
  props: {
    data: {}
  },
  components:{
   [Field.name]: Field,
   [Cascader.name]: Cascader,
   [Popup.name]: Popup
  },
  data() {
    return {
      addres: "",
      districtList: "",
      cityCode: "",
      keyWords: "",
      map: {},
      marker: {},
      position: [],
      address_list: [],

      cascaderValue: "",
      show:false,
      options: [
        // {
        //   name: '浙江省',
        //   code: '330000',
        //   items: [{ name: '杭州市', code: '330100' }],
        // },
        // {
        //   name: '江苏省',
        //   code: '320000',
        //   items: [{ name: '南京市', code: '320100' }],
        // },
      ],
      fieldNames: {
        text: 'name',
        value: 'code',
        children: 'children',
      },
      province:"加载中...",
      city:"",
    }
  },
  created() {
    this.initAMap();
    this.getJson();
  },
  mounted() {

  },
  methods: {
    //地图初始化
    initAMap() {
      let that = this;
      AMapLoader.load({
          key: "64b57e78375cf0a4626d0b459296957e", //申请好的Web端开发者Key，首次调用 load 时必填
          version: "2.0",
          plugins: ["AMap.Geocoder","AMap.Geolocation","AMap.Autocomplete'"]
        })
        .then(Amap => {
          AMap = Amap;
          // 其他功能同h5
          this.map = new AMap.Map("container", {
            // viewMode: "3D",
            center: [116.857461, 41.310582], // 地图中心点坐标
            zoom: 15 ,// 地图缩放级别
          });
          this.getLocation();
        })
        .catch(e => {
          console.log("高德地图加载错误", e);
        });
    },

    // 获取位置
    getLocation() {
      let that = this;
      AMap.plugin("AMap.Geolocation", function() {
        let geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          timeout: 10000, //超过10秒后停止定位，默认：无穷大
          maximumAge: 0, //定位结果缓存0毫秒，默认：0
          convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          showButton: true, //显示定位按钮，默认：true
          buttonPosition: "LB", //定位按钮停靠位置，默认：'LB'，左下角
          buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
          showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
          showCircle: false, //定位成功后用圆圈表示定位精度范围，默认：true
          panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
          zoomToAccuracy: true //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
        });

        that.map.addControl(geolocation); // 右下角 获取当前位置控件
        that.map.on("click", showInfoClick);//手动地图选取点位
        function showInfoClick(e) {
          console.log(e, " this. this. this.");
          let center = [e.lnglat.lng,e.lnglat.lat]
          that.map.setCenter(center);
          that.map.setZoomAndCenter(1,center);
        }

        geolocation.getCityInfo((status, result) => {
          //只能获取当前用户所在城市和城市的经纬度
          if (status == 'complete') {
              console.log('所在城市和城市', result);
              that.province = result.province;
              that.city = result.city;
          }else{
            that.province = "北京市";
            that.city = "北京市";
          }
        });

        // 获取详细地址api
        geolocation.getCurrentPosition(function(status, result) {
          if (status == "complete") {
            onComplete(result);
          } else {
            onError(result);
          }
        });

        function onComplete(data) {
          // data是具体的定位信息
          // alert(JSON.stringify(data));
          console.log("定位信息------",data)
          that.position = data.position;
          that.searchNear(that.position);
        }

        function onError(data) {
          // 定位出错
          console.log(data, "onError");
        }
      });
    },
    getPosLngLat(center) {
          const { lng, lat } = center;
          return new AMap.LngLat(lng, lat);
    },


    // 关键字搜索
    searchNear() {
      let that = this;
      AMap.plugin(["AMap.AutoComplete", "AMap.PlaceSearch"], function() {
        var autoOptions = {
          // 城市，默认全国
          city: that.city,
          // 使用联想输入的input的id
          input: "keyWords",
          datatype: "all" //返回的数据类型
        };
        console.log("autoOptions-------",autoOptions);
        var autocomplete = new AMap.AutoComplete(autoOptions);
        const placeSearch = new AMap.PlaceSearch({
          city: that.city, // 兴趣点城市，支持城市名、citycode、adcode
          citylimit: true, // 是否强制在设置的城市内搜索，默认false
          // type: "商务住宅|公司企业|餐饮服务|科教文化服务|政府机构及社会团体", // 兴趣点类别，用‘|’分隔，默认：'餐饮服务|商务住宅|生活服务'
          type: "", // 兴趣点类别，用‘|’分隔，默认：'餐饮服务|商务住宅|生活服务'
          pageSize: 30, // 每页条数，默认10，范围1-50
          pageIndex: 1, // 页码
          extensions: "all", // 默认base，返回基本地址信息；all：返回详细信息
          map: that.map, // 地图实例，可选
          // panel: 'addressList', // 结果列表的id容器，可选
          autoFitView: false // 是否自动调整地图视野到marker点都处于可见范围
        });

        function select(e) { //选中地址处理的事件
        console.log("e-------",e)
          that.keyWords = e.poi.name;
          that.position = [e.poi.location.lng, e.poi.location.lat];
          placeSearch.setCity(e.poi.adcode);
          // placeSearch.search(e.poi.name); //关键字查询查询
          that.map.setCenter(that.position);
          that.drawMarker({lng:e.poi.location.lng, lat:e.poi.location.lat})

          that.address_list = [];
           placeSearch.search(e.poi.name, function(status, result) {
            console.log("result-------",result)
            // 搜索成功时，result即是对应的匹配数据
            that.address_list = result.poiList.pois.map(poi => ({
              name: poi.name,
              address: poi.address, // 确保地址信息完整
              city: poi.cityname, // 城市名
              province: poi.pname, // 省份名
              district: poi.adname ,// 区域名
              location:poi.location,//经纬度
            }))
          })
        }
        autocomplete.on("select", select); //注册监听，当选中某条记录时会触发
        placeSearch.searchNearBy("", that.position, 200000, function(
          status,
          result
        ) {
          console.log("result-------",result)
          that.address_list = result.poiList.pois.map(poi => ({
            name: poi.name,
            address: poi.address, // 确保地址信息完整
            city: poi.cityname, // 城市名
            province: poi.pname, // 省份名
            district: poi.adname ,// 区域名
            location:poi.location,//经纬度
          }))
        });
      });


    },
    drawMarker(location) {
      if (location == null) return
      let longitude = location.lng,
        latitude = location.lat
      if (marker) {
        marker.setMap(null);
      }
      marker = new AMap.Marker({
        position: new AMap.LngLat(longitude, latitude),
        anchor: 'bottom-center',

      });

      marker.on('click', () => {
        // this.coord = location;
      })
      this.map.add(marker);
      this.map.setCenter([longitude, latitude])
      // this.map.setZoomAndCenter(16, [longitude, latitude]);
    },
    sureAddress(item){
      console.log(item,'item');
      this.$emit('addressInfo', item);
    },

    open() {
      console.log("点击省市--------")
      this.show = true
    },

    //获取二级地址
    getJson(){
      getGeoTwoData().then(res=> {
       console.log(res)
        this.options = res.data;
      })
    },

    onFinish({ selectedOptions }) {
      this.province = selectedOptions[0].name
      this.provinceId = selectedOptions[0].code
      this.city = selectedOptions[1].name
      this.cityId = selectedOptions[1].code
      if(selectedOptions.length==2){
        this.show = false
      }
      console.log("province-----",this.province)
      console.log("city---------",this.city)
      this.searchNear();

    },
    onChange(val) {
      if(val.tabIndex == 2){
        let code = val.selectedOptions[2].code
      }
      console.log(val,'1111')
    }


  },
}



// WEBPACK FOOTER //
// ./src/view/address/map.vue